<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <DatePicker v-model="filter.year" type="year" format="yyyy" style="width:110px" placeholder="年度"></DatePicker>
      </Cell>
      <Cell>
        <Select v-model="filter.month" style="width:90px" :allow-clear="true" placeholder="月份">
          <Option v-for="m in 12" :value="m" :key="m">{{ m }}月</Option>
        </Select>
      </Cell>
      <Cell>
        <input class="h-input" v-model="filter.name" placeholder="姓名" style="width:110px">
      </Cell>
      <Cell>
        <Select v-model="filter.declareStatus" style="width:110px" :allow-clear="true" placeholder="申报状态">
          <Option :value="0">未申报</Option>
          <Option :value="1">已申报</Option>
        </Select>
      </Cell>
      <Cell>
        <Button color="primary" @click="loadList">查询</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="openAdd">新增记录</Button>
      </Cell>
      <Cell>
        <Button @click="doMissingCheck">漏报检查</Button>
      </Cell>
    </Row>

    <!--汇总-->
    <Row :space-x="10" class="margin-right-left" type="flex" v-if="summary">
      <Cell v-for="card in summaryCards" :key="card.label" class="stat-card">
        <div class="stat-label">{{ card.label }}</div>
        <div class="stat-value">{{ card.value }}</div>
      </Cell>
    </Row>

    <!--明细列表-->
    <div class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading">
        <TableItem title="所属期" :width="100">
          <template slot-scope="{data}">{{ data.year }}-{{ String(data.month).padStart(2, '0') }}</template>
        </TableItem>
        <TableItem title="姓名" prop="name" :width="100"></TableItem>
        <TableItem title="证件号码" prop="certNo" :width="170"></TableItem>
        <TableItem title="当期收入" align="right">
          <template slot-scope="{data}">{{ money(data.currentIncome) }}</template>
        </TableItem>
        <TableItem title="累计收入" align="right">
          <template slot-scope="{data}">{{ money(data.cumulativeIncome) }}</template>
        </TableItem>
        <TableItem title="累计应纳税所得额" align="right">
          <template slot-scope="{data}">{{ money(data.cumulativeTaxableIncome) }}</template>
        </TableItem>
        <TableItem title="税率" :width="80" align="center">
          <template slot-scope="{data}">{{ rateText(data.rate) }}</template>
        </TableItem>
        <TableItem title="本期应补(退)税" align="right">
          <template slot-scope="{data}">
            <b :class="Number(data.currentTax) > 0 ? 'tax-need' : ''">{{ money(data.currentTax) }}</b>
          </template>
        </TableItem>
        <TableItem title="状态" :width="90" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.declareStatus === 1 ? 'success' : 'warning'">
              {{ data.declareStatus === 1 ? '已申报' : '未申报' }}
            </Tag>
          </template>
        </TableItem>
        <TableItem title="操作" :width="80" align="center">
          <span slot-scope="{data}" class="link" @click="openEdit(data)">编辑</span>
        </TableItem>
      </Table>
      <Pagination :page="filter.page" size="small" :total="total" @change="onPage" class="margin-top text-right"></Pagination>
    </div>

    <!--编辑弹窗-->
    <Modal v-model="modal" :title="form.id ? '编辑个税记录' : '新增个税记录'" width="820">
      <div class="form-scroll">
        <Form ref="form" mode="twocolumn" :labelWidth="140" :model="form" :rules="validationRules">
          <FormItem label="年度" prop="year">
            <input type="number" v-model.number="form.year">
          </FormItem>
          <FormItem label="月份" prop="month">
            <input type="number" min="1" max="12" v-model.number="form.month">
          </FormItem>
          <FormItem label="姓名" prop="name">
            <input type="text" v-model="form.name">
          </FormItem>
          <FormItem label="证件号码" prop="certNo">
            <input type="text" v-model="form.certNo">
          </FormItem>
          <FormItem label="当期收入额">
            <input type="number" v-model.number="form.currentIncome">
          </FormItem>
          <FormItem label="当期免税收入">
            <input type="number" v-model.number="form.currentTaxFree">
          </FormItem>
          <FormItem label="养老保险(个人)">
            <input type="number" v-model.number="form.pension">
          </FormItem>
          <FormItem label="医疗保险(个人)">
            <input type="number" v-model.number="form.medical">
          </FormItem>
          <FormItem label="失业保险(个人)">
            <input type="number" v-model.number="form.unemployment">
          </FormItem>
          <FormItem label="住房公积金(个人)">
            <input type="number" v-model.number="form.housingFund">
          </FormItem>
          <FormItem label="累计子女教育">
            <input type="number" v-model.number="form.childrenEducation">
          </FormItem>
          <FormItem label="累计继续教育">
            <input type="number" v-model.number="form.continuingEducation">
          </FormItem>
          <FormItem label="累计住房贷款利息">
            <input type="number" v-model.number="form.housingLoan">
          </FormItem>
          <FormItem label="累计住房租金">
            <input type="number" v-model.number="form.housingRent">
          </FormItem>
          <FormItem label="累计赡养老人">
            <input type="number" v-model.number="form.elderlyCare">
          </FormItem>
          <FormItem label="累计婴幼儿照护">
            <input type="number" v-model.number="form.infantCare">
          </FormItem>
          <FormItem label="其他扣除">
            <input type="number" v-model.number="form.otherDeduction">
          </FormItem>
          <FormItem label="准予扣除捐赠额">
            <input type="number" v-model.number="form.donation">
          </FormItem>
          <FormItem label="减免税额">
            <input type="number" v-model.number="form.taxReduction">
          </FormItem>
          <FormItem label="备注">
            <textarea v-model="form.remark" rows="2"></textarea>
          </FormItem>
        </Form>
      </div>
      <div slot="bottom">
        <Button @click="modal = false">取消</Button>
        <Button color="primary" @click="doSave" :loading="saving">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
const emptyForm = {
  id: null, year: null, month: null, name: '', certNo: '',
  currentIncome: 0, currentTaxFree: 0,
  pension: 0, medical: 0, unemployment: 0, housingFund: 0,
  childrenEducation: 0, continuingEducation: 0, housingLoan: 0, housingRent: 0,
  elderlyCare: 0, infantCare: 0,
  otherDeduction: 0, donation: 0, taxReduction: 0, remark: ''
};

export default {
  name: 'IitDeclare',
  data() {
    let now = new Date();
    return {
      filter: {
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        name: '',
        declareStatus: null,
        page: 1
      },
      list: [],
      total: 0,
      loading: false,
      summary: null,
      modal: false,
      saving: false,
      form: HeyUtils.copy(emptyForm),
      validationRules: {
        required: ['year', 'month', 'name', 'certNo']
      }
    };
  },
  computed: {
    summaryCards() {
      if (!this.summary) {
        return [];
      }
      return [
        {label: '记录总数', value: this.summary.total},
        {label: '已申报', value: this.summary.declaredCount},
        {label: '未申报', value: this.summary.undeclaredCount},
        {label: '应补(退)税额合计', value: this.money(this.summary.taxAmountTotal)}
      ];
    }
  },
  methods: {
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    rateText(rate) {
      let n = Number(rate);
      return isNaN(n) ? '-' : (n * 100).toFixed(0) + '%';
    },
    loadList() {
      this.loading = true;
      let params = Object.assign({page: this.filter.page, pageSize: 20}, this.filter);
      this.$api.pro.iit.list(params).then(({data}) => {
        this.list = data.results || [];
        this.total = data.total || 0;
      }).finally(() => this.loading = false);
      this.$api.pro.iit.summary({year: this.filter.year, month: this.filter.month}).then(({data}) => {
        this.summary = data;
      }).catch(() => {});
    },
    onPage(page) {
      this.filter.page = page;
      this.loadList();
    },
    openAdd() {
      this.form = HeyUtils.copy(emptyForm);
      this.form.year = this.filter.year;
      this.form.month = this.filter.month;
      this.modal = true;
    },
    openEdit(row) {
      this.form = HeyUtils.copy(row);
      this.modal = true;
    },
    doSave() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      this.saving = true;
      this.$api.pro.iit.save(this.form).then(() => {
        this.$Message.success('保存成功，税额已按累计预扣法计算');
        this.modal = false;
        this.loadList();
      }).finally(() => this.saving = false);
    },
    doMissingCheck() {
      this.$api.pro.iit.missingCheck({year: this.filter.year, month: this.filter.month}).then(({data}) => {
        if (!data.results || data.results.length === 0) {
          this.$Message.success('未发现漏报人员');
        } else {
          this.$Modal.alert({
            title: `发现 ${data.total} 名可能漏报人员`,
            content: data.results.map(r => `${r.name}（${r.dept || '-'}）：${r.tip}`).join('<br>')
          });
        }
      });
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.stat-card {
  flex: 1;
  margin: 10px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  .stat-label {
    color: #808695;
    font-size: 13px;
  }
  .stat-value {
    margin-top: 6px;
    font-size: 20px;
    font-weight: bold;
    color: #2d8cf0;
  }
}
.tax-need {
  color: #ed4014;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
}
.form-scroll {
  max-height: 460px;
  overflow-y: auto;
}
.margin-top {
  margin-top: 10px;
}
</style>
